import React from 'react';
import './../../../app/';
import '../../../css/components/_fullloader.less';

const TgsFullLoader = props => {
    const { fullpage = false, loadingText = '' } = props;
    return (
        <div className={fullpage ? "full-tgsloader_container" : "tgsloader_container"}>
            <div className="tgsloader" >{loadingText}</div>
        </div>
    );
};
export default TgsFullLoader;
